import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PartnerIndexComponent } from './crud-index/crud-index.component';
import { PartnerCESComponent } from './crud-ces/crud-ces.component';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';

const routes: Routes = [
  {
    path: '',
    component: PartnerIndexComponent,
  },
  {
    path: 'new',
    component: PartnerCESComponent,
    data: { type: TypeCesEnum.NEW },
  },
  {
    path: 'show/:id',
    component: PartnerCESComponent,
    data: { type: TypeCesEnum.SHOW },
  },
  {
    path: 'edit/:id',
    component: PartnerCESComponent,
    data: { type: TypeCesEnum.EDIT },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PartnersRoutingModule {}
